$(function(){
    updateFooter()
})

function updateFooter(){
    let obt = $(".footer")
    if (obt[0].offsetTop < $(window).height()){
        obt[0].style.position = "fixed"
        obt[0].style.bottom = "0"
        obt[0].style.width = "100%"
    }else{
        obt[0].style.position = "statics"
    }
    console.log($(window).height(), obt[0].offsetTop)
}